import React from "react";
import "./Gameplay.css";
import Seekers from "./gameplay/Seekers";
import Equipment from "./gameplay/Equipment";
import Actions from "./gameplay/Actions";

const Gameplay: React.FC = () => {
  return (
    <section id="gameplay" className="gameplay-section">
      {/* Seekers Subsection */}
      <Seekers />

      {/* Equipment Subsection */}
      <Equipment />

      {/* Actions Subsection */}
      <Actions />
    </section>
  );
};

export default Gameplay;
